<div class="comparison-page">
  <div class="review-banner">
    <div class="review-banner-main">
      <button
        class="btn btn-control comparison-back"
        (click)="closeMatchingTab()"
        [disabled]="isSavingMatchReview"
        [title]="app.text.thread.close"
        >
        <i class="far fa-arrow-left"></i>
        <span>{{ app.text.matchingManufacturer.backToMatchingQueue }}</span>
      </button>

      <div class="comparison-heading-row review-banner-heading-row">
        <div>
          <div class="comparison-title">
            {{ app.text.matchingManufacturer.reviewMatchCustomerPartNumber }}
            — {{ reviewTitle }}
          </div>
        </div>

        <div class="comparison-status-pill" [ngClass]="getStatusClass()">
          {{ matchingStatusLabel }}
        </div>
      </div>
    </div>
  </div>

  <div class="comparison-card">
    <div class="comparison-table-wrap">
      <table class="table comparison-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ app.text.matchingManufacturer.originalData }}</th>
            <th>
              <div class="comparison-current-header">
                <span>{{ app.text.matchingManufacturer.currentMatch }}</span>
                @if (hasDatasheet) {
                  <a
                    class="comparison-header-link"
                    [href]="manufacturer.datasheet"
                    target="_blank"
                    [title]="app.text.matchingManufacturer.datasheet"
                    >
                    <i class="fas fa-file icon-blue"></i>
                    <span>{{ app.text.matchingManufacturer.datasheet }}</span>
                  </a>
                }
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (row of comparisonRows; track row.key) {
            <tr>
              <td class="comparison-label-cell">
                <div class="comparison-label">
                  <span class="comparison-label-icon">
                    <i [class]="row.icon"></i>
                  </span>
                  <span>{{ row.label }}</span>
                </div>
              </td>
              <td class="comparison-value-cell">
                @if (isImportedValueBadge(row)) {
                  @if (row.key === 'lifecycle') {
                    <span
                      class="badge badgeStatus original-status-badge"
                      [ngStyle]="getImportedValueStyle(row)"
                      >
                      {{ row.importedValue || "—" }}
                    </span>
                  } @else {
                    <span
                      class="badge review-value-badge"
                      [ngStyle]="getImportedValueStyle(row)"
                      >
                      {{ row.importedValue || "—" }}
                    </span>
                  }
                } @else {
                  <div class="comparison-value">{{ row.importedValue }}</div>
                }
              </td>
              <td class="comparison-value-cell comparison-value-selected">
                @if (row.key === 'lifecycle') {
                  <span
                    class="badge badgeStatus original-status-badge"
                    [ngStyle]="getSelectedValueStyle(row)"
                    >
                    {{ getSelectedValueLabel(row) || "—" }}
                  </span>
                } @else {
                  @if (isSelectedValueBadge(row)) {
                    <span
                      class="badge review-value-badge"
                      [ngStyle]="getSelectedValueStyle(row)"
                      >
                      {{ getSelectedValueLabel(row) || "—" }}
                    </span>
                  } @else {
                    <span class="comparison-value">
                      {{ getSelectedValueLabel(row) }}
                    </span>
                  }
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div id="better-match-section">
    <app-external-data-filter
      [manufacturerId]="manufacturer._id"
      [matchReviews]="matchReviews"
      (manufacturerStatusChanged)="onManufacturerStatusChanged($event)"
      (savingStateChanged)="onSavingStateChanged($event)"
    ></app-external-data-filter>
  </div>
</div>
